import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DeviceService } from 'src/app/device/shared/services/device.service';
import { ProjectRouteStation } from 'src/app/project/shared/interfaces/project-route-station.interface';
import { Project } from 'src/app/project/shared/interfaces/project.interface';
import { ProjectService } from 'src/app/project/shared/services/project.service';
import { RouteStationService } from 'src/app/project/shared/services/route-station.service';
import { SelectionOutput } from '../../interfaces/new-reporting-filter';

@Component({
  selector: 'avs-reporting-menu',
  standalone: false,
  templateUrl: './reporting-menu.component.html',
  styleUrl: './reporting-menu.component.css'
})

export class ReportingMenuComponent implements OnInit, OnChanges {
  @Input() selectedMenu: string = "";
  @Input() searchFilter: string = "";
  @Input() selectedStatus: string = "";

  @Output() selectionChange = new EventEmitter<SelectionOutput>();

  selection?: SelectionOutput;

  projects: Project[] = [];
  allRouteStations: ProjectRouteStation[] = [];
  filteredProjects: Project[] = [];
  filteredRouteStations: ProjectRouteStation[] = [];

  constructor(private projectService: ProjectService,
    private routeStationService: RouteStationService, // timezone bei projektlosen routeStations nicht geklärt --> vorerst nur laden
    private deviceService: DeviceService      // für Filterung der Berichte --> Verkehrdatenbericht
  ) { }

  ngOnInit(): void {
    this.projectService.getProjects().subscribe(projects => {
      this.projects = projects;
      this.filterResource();
    });
    this.routeStationService.getRouteStations().subscribe(routeStations => {
      this.allRouteStations = routeStations;
    });
  }

  public onSelectionChange(selection: SelectionOutput) {
    this.selection = selection;
    this.selectionChange.emit(selection);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedMenu'] || changes['searchFilter'] || changes['selectedStatus']) {
      this.filterResource();
      this.selection = undefined;      /* ToDo: For now, always reset selection. Better: Determine, wether selection is valid yet? */
      this.selectionChange.emit(this.selection);
    }
  }

  filterResource() {
    let filteredByStatus = this.filterByStatus(this.projects);
    this.filteredProjects = filteredByStatus.filter(project =>
      project.name.toLowerCase().includes(this.searchFilter.toLowerCase()) ||
      project.groups.some(group =>
        group.name.toLowerCase().includes(this.searchFilter.toLowerCase())
      )
    );
    this.filteredRouteStations = this.allRouteStations.filter(rs =>
      rs.name.toLowerCase().includes(this.searchFilter.toLowerCase()) ||
      (rs.samId && rs.samId.toString().toLowerCase().includes(this.searchFilter.toLowerCase()))
    );
  }

  filterByStatus(projects: Project[]): Project[] {
    if (this.selectedStatus === 'aktiv') {
      return projects.filter(project => project.isActive);
    } else if (this.selectedStatus === 'inaktiv') {
      return projects.filter(project => !project.isActive);
    } else {
      return projects;
    }
  }

  getTimezoneIdForRouteStation(routeStation: ProjectRouteStation): string {
    if (routeStation.groupId != undefined)
    {
      var currentProject = this.projects.find(project => project.groups.find(group => group.id == routeStation.groupId));
      if (currentProject != undefined)
        return(currentProject.timezoneId);
    }
    return 'Europe/Berlin'; // vorerst fest kodiert, demnächst hoffentlich keine RouteStations mehr ohne Projekt?
  }

  isInGroup(routeStation: ProjectRouteStation): string {
    return routeStation.groupId ? 'In Gruppe' : 'KEINE ZEITZONE ZU ERMITTELN';
  }
}